import { useContext, createContext, useReducer } from "react";
import { useAuth } from "./authContext"
import axios from "axios";

const CartContext = createContext();

const CartProvider = ({ children }) => {
	const { authDispatch } = useAuth();

	const config = {
		headers: {
			authorization: localStorage.getItem('token')
		}
	}

	const addToCart = async (item, toastText) => {
		try {
			const response = await axios.post("/api/user/cart", {
				product: item
			}, config
			)
			if (response.status === 201) {
				authDispatch({ type: 'ADD_TO_CART', payload: { toastMessage: toastText, data: response.data.cart } })
			}
		} catch (error) {
			console.log(error)
		}
	}

	const removeFromCart = async (_id, toastText) => {
		try {
			const response = await axios.delete(`/api/user/cart/${_id}`, config)
			if (response.status === 200) {
				authDispatch({ type: "REMOVE_FROM_CART", payload: { toastMessage: toastText, data: response.data.cart } })
			}
		} catch (error) {
			console.log(error)
		}
	}

	const updateCartQuantity = async (_id, actionType, toastText) => {
		try {
			const response = await axios.post(`/api/user/cart/${_id}`, {
				action: {
					type: actionType
				}
			}, config)
			if (response.status === 200) {
				authDispatch({ type: "UPDATE_CART", payload: { toastMessage: toastText, data: response.data.cart } })
			}
		} catch (error) {
			console.log(error)
		}
	}


	return (
		<CartContext.Provider value={{ addToCart, removeFromCart, updateCartQuantity }}>{children}</CartContext.Provider>
	)
}

const useCart = () => useContext(CartContext);

export { CartProvider, useCart }
